module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "id": "client-modal",
      "size": "modal-md",
      "data-backdrop": "static",
      "data-keyboard": "true",
      "closable": _vm.client !== null,
      "closeFunction": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "page-title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalCliente.labels.clientes'))
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalCliente.titulos.selecioneCliente'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('v-client-table', {
    staticClass: "data-table select-client-table custom-data-table table-thead-cursor-pointer",
    attrs: {
      "data": _vm.clients,
      "columns": _vm.columns,
      "options": _vm.options,
      "show-pagination": false
    },
    on: {
      "row-click": _vm.rowClick
    },
    scopedSlots: _vm._u([{
      key: "nomeFantasia",
      fn: function(props) {
        return [_c('div', {
          staticClass: "pull-left"
        }, [_c('label', {
          class: props.row.id === _vm.client ? 'selector-selected' : 'selector-unselected'
        }, [_vm._v(_vm._s(props.row.nomeFantasia))])]), _c('div', {
          staticClass: "pull-right"
        }, [_c('label', {
          class: props.row.id === _vm.client ? 'selector-selected' : 'selector-unselected'
        }, [_c('i', {
          staticClass: "selector-icon fa fa-check"
        }), _c('span', {
          domProps: {
            "innerHTML": _vm._s(props.row.id === _vm.client ? _vm.$t('modalCliente.labels.selecionado') : _vm.$t('modalCliente.labels.selecionar'))
          }
        })])])]
      }
    }])
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0049b780", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0049b780"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/clientModal/clientModal.pug
// module id = 1356
// module chunks = 0